<template>
	<div>
		<base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
		</base-header>
		<div class="container-fluid mt--9">
			<div class="row pb-3">
				<div class="col-12 col-xl-9 mb-3 mb-xl-0">
					<div class="card shadow">
						<div v-if="customer">
							<div class="card-header bg-transparent">
								<div class="d-flex">
									<div class="flex-grow-1">
										<h3 class="m-0">{{ customer.CardName }}</h3>
										<h5 class="text-muted m-0">{{ customer.CardCode }}</h5>
									</div>
									<div>
										<base-button
											v-if="['federicoflores@canplast.com.mx',
														'bereniceterrazas@canplast.com.mx',
														'darinkahernandez@canplast.com.mx',
														'dannasandoval@canplast.com.mx',
														'leslysifuentes@canplast.com.mx',
														'alfredoreyes@canplast.com.mx'].includes(user.email) && !edit"
											@click="edit = true" 
											icon="fa fa-pen"
											size="sm">
											Editar
										</base-button>
									</div>
								</div>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-12 col-sm-6 col-xl-4">
										<base-input 
											label="RFC" 
											v-model="customer.FederalTaxID" 
											inputClasses="input-group-alternative"
											disabled>
										</base-input>
									</div>
									<div class="col-12 col-sm-6 col-xl-4">
										<base-input 
											label="Correo electrónico" 
											v-model="customer.EmailAddress"
											inputClasses="input-group-alternative" 
											:disabled="!edit">
										</base-input>
									</div>
									<div class="col-12 col-sm-6 col-xl-4">
										<base-input 
											label="Teléfono" 
											v-model="customer.Phone1" 
											inputClasses="input-group-alternative"
											:disabled="!edit">
									</base-input>
									</div>
									<div class="col-12 col-sm-6 col-xl-4">
										<base-input 
											label="Calle" 
											v-model="customer.BPAddresses[0].Street" 
											inputClasses="input-group-alternative"
											disabled>
									</base-input>
									</div>
									<div class="col-6 col-sm-3 col-xl-2">
										<base-input 
											label="No. Exterior" 
											v-model="customer.BPAddresses[0].StreetNo" 
											inputClasses="input-group-alternative"
											disabled>
										</base-input>
									</div>
									<div class="col-6 col-sm-3 col-xl-2">
										<base-input 
											label="No. Interior" 
											v-model="customer.BPAddresses[0].BuildingFloorRoom" 
											inputClasses="input-group-alternative"
											disabled>
										</base-input>
									</div>
									<div class="col-12 col-sm-6 col-xl-4">
										<base-input 
											label="Colonia" 
											v-model="customer.BPAddresses[0].Block" 
											inputClasses="input-group-alternative"
											disabled>
										</base-input>
									</div>
									<div class="col-12 col-sm-6 col-xl-4">
										<base-input 
											label="Código Postal" 
											v-model="customer.BPAddresses[0].ZipCode"
											inputClasses="input-group-alternative"
											disabled>
										</base-input>
									</div>
									<div class="col-12 col-sm-6 col-xl-4">
										<label for="Estado" class="form-control-label">Estado</label>
										<multiselect 
											v-model="selectedState" 
											placeholder="Estado" 
											:options="stateOptions"
											label="name"
											track-by="code"
											class="mb-4"
											disabled>
										</multiselect>
									</div>
									<div class="col-12 col-sm-6 col-xl-4">
										<base-input 
											label="Municipio" 
											v-model="customer.BPAddresses[0].City" 
											inputClasses="input-group-alternative"
											disabled>
										</base-input>
									</div>
								</div>
							</div>
							<div class="card-footer">
								<div class="d-flex justify-content-end">
									<base-button 
										@click="getCustomer();" 
										type="white" 
										:class="[edit ? 'visible' : 'invisible']"
										:disabled="savingCustomer">
										Cancelar
									</base-button>
									<base-button 
										@click="updateCustomer()" 
										icon="fa fa-check" 
										:class="[edit ? 'visible' : 'invisible']"
										:disabled="savingCustomer">
										Guardar cambios
									</base-button>
								</div>
							</div>
						</div>
						<div v-if="!customer" class="card-body">
							<base-loader class="py-9"></base-loader>
						</div>
					</div>
				</div>
				<div class="col-12 col-xl-3 d-flex flex-column">
					<div class="card shadow h-50 d-flex justify-content-center mt-3 mt-xl-0 mb-3 py-4">
						<div class="d-flex flex-column align-items-center justify-content-center">
							<div class="icon icon-shape text-white rounded-circle shadow bg-gradient-green">
								<i class="fa fa-money-bill"></i>
							</div>
							<h5 class="card-title text-uppercase text-muted mt-4 my-3">Saldo Actual</h5>
							<span class="h2 font-weight-bold m-0" v-if="customer">{{formatBalance(customer.CurrentAccountBalance)}}</span>					
						</div>
					</div>
					<div class="card shadow h-50 d-flex justify-content-center mt-3 py-4">
						<div class="d-flex flex-column align-items-center justify-content-center">
							<div class="icon icon-shape text-white rounded-circle shadow bg-gradient-info">
								<i class="fa fa-box-open"></i>
							</div>
							<h5 class="card-title text-uppercase text-muted mt-4 my-3">Pedidos Abiertos</h5>
							<span class="h2 font-weight-bold m-0" v-if="customer">{{formatBalance(positiveOpenOrdersBalance(customer.OpenOrdersBalance))}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="row py-3">
				<div class="col">
					<div class="card shadow">
							<tabs tabContentClasses="mb-5" tabNavClasses="px-4 py-3">
								<tab title="Cotizaciones">
									<div class="d-flex justify-content-end px-4">
										<base-button @click="navNewQuotation()" icon="fa fa-plus">
											Nueva Cotización
										</base-button>
									</div>
									<data-table id="dt_quotations" v-bind="dtQuotations"/>
								</tab>
								<tab title="Pedidos">
									<data-table id="dt_orders" v-bind="dtOrders" />
								</tab>
								<tab title="Facturas">
									<data-table id="dt_invoices" v-bind="dtInvoices" />
								</tab>
								<tab title="Notas Crédito">
									<data-table id="dt_notes" v-bind="dtNotes" />
								</tab>
								<tab title="Contactos">
									<data-table id="dt_contacts" v-bind="dtContacts" />
								</tab>
								<tab title="Datos Fiscales">
									<ul v-if="customer" class="list-group list-group-flush px-4">
										<li class="list-group-item">
											<div class="row">
												<h5 class="col-4 text-muted pl-4">Razón Social</h5>
												<h5 class="col-8">{{ taxData.cardName }}</h5>
											</div>
										</li>
										<li class="list-group-item">
											<div class="row">
												<h5 class="col-4 text-muted pl-4">RFC</h5>
												<h5 class="col-8">{{ taxData.federalTaxID }}</h5>
											</div>
										</li>
										<li class="list-group-item">
											<div class="row">
												<h5 class="col-4 text-muted pl-4">Régimen Fiscal</h5>
												<h5 class="col-8" v-if="taxData.U_TS_RegFiscal">
													{{ taxData.U_TS_RegFiscal.Code }} - {{ taxData.U_TS_RegFiscal.Name }}
												</h5>
											</div>
										</li>
										<li class="list-group-item">
											<div class="row">
												<h5 class="col-4 text-muted pl-4">Código Postal</h5>
												<h5 class="col-8">{{ taxData.zipCode }}</h5>
											</div>
										</li>
										<li class="list-group-item">
											<div class="row">
												<h5 class="col-4 text-muted pl-4">CFDI</h5>
												<h5 class="col-8" v-if="taxData.U_B1SYS_MainUsage">
													{{ taxData.U_B1SYS_MainUsage.name }}
												</h5>
											</div>
										</li>
										<li class="list-group-item" v-if="taxData.U_FiscalCertificateLink">
											<div class="row">
												<h5 class="col-4 text-muted pl-4">
													<a :href="taxData.U_FiscalCertificateLink">Ver Constancia Fiscal </a>
												</h5>
											</div>
										</li>
									</ul>
								</tab>
							</tabs>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal Quotation Details -->
		<b-modal hide-footer v-model="modal.quotation" size="xl" bodyClass="p-0">
			<template #modal-header v-if="modal.quotation && currentQuotation && !loadingQuotation">
				<div class="d-lg-flex justify-content-between w-100">
					<div>
						<h3 class="text-uppercase">Cotización 
							<span class="badge badge-success badge-pill text-sm" style="letter-spacing: .5px;">
								#{{ currentQuotation.DocNum }}
							</span>
						</h3>
						<span class="text-sm text-muted">{{currentQuotation.CardName}}</span>
					</div>
					<div class="d-flex align-items-center justify-content-between text-default">
						<table class="text-lg-right text-xs mr-3">
							<tr>
								<th class="pr-4"><b>Fecha de creación</b></th>
								<td>{{ currentQuotation.DocDate }}</td>
							</tr>
							<tr>
								<th class="pr-4"><b>Fecha de vencimiento</b></th>
								<td>{{ currentQuotation.DocDueDate }}</td>
							</tr>
						</table>
						<div>
							<base-button
							@click="downloadPdfFile('QUT20007', currentQuotation, 'Cotización')" 
							v-if="!editQuotation" 
							type="default" 
							icon="fa fa-file-pdf" 
							size="sm">
								Descargar
							</base-button>
							<base-button
								@click="editQuotation = true" 
								v-if="!editQuotation" 
								type="success" 
								icon="fa fa-pen" 
								size="sm">
								Editar
							</base-button>
							<base-button 
								@click="getQuotation(currentQuotation.DocNum)" 
								v-if="editQuotation"
								:disabled="savingQuotation"
								type="white" 
								size="sm">
								Cancelar edición
							</base-button>							
						</div>
					</div>
				</div>
			</template>
			
			<div v-if="modal.quotation && currentQuotation && !loadingQuotation" class="mt-n3 modal-body pb-0">
				<div class="row pl-4">
						<div class="col-6 col-lg-3">
							<h5>Almacén <span v-if="editQuotation">*</span></h5>
							<p class="text-xs" v-if="!editQuotation"><b>{{selectedWhs}}</b></p>
							<div class="" v-else>
								<multiselect 
									v-model="selectedWhs"
									:options="warehouseOptions"
									class="mb-4">
								</multiselect>								
							</div>
						</div>
						<div class="col-6 col-lg-3">
							<h5>Moneda <span v-if="editQuotation">*</span></h5>
							<p class="text-xs" v-if="!editQuotation"><b>{{ currentQuotation.DocCurrency }}</b></p>
							<multiselect 
								v-model="currentQuotation.DocCurrency"
								:options="currencyOptions"
								class="mb-4"
								v-else>
							</multiselect>
						</div>	
						<div class="col-6 col-lg-3">
							<h5>Vendedor <span v-if="editQuotation">*</span></h5>
							<p class="text-xs" v-if="!editQuotation"><b>{{ findSalesPerson(currentQuotation.SalesPersonCode).SalesEmployeeName }}</b></p>
							<multiselect 
								v-model="selectedSalesPerson"
								:options="salesPersonOptions"
								label="SalesEmployeeName"
								track-by="SalesEmployeeCode"
								class="mb-4"
								v-else>
							</multiselect>
						</div>
						<div class="col-6 col-lg-3">
							<h5>Referencia</h5>
							<p class="text-xs" v-if="!editQuotation"><b>{{ currentQuotation.NumAtCard }}</b></p>
							<base-input 
								inputClasses="input-group-alternative"
								placeholder="Referencia" 
								v-model="currentQuotation.NumAtCard" 
								v-else>
							</base-input>
						</div>
						<div class="col-12 col-lg-6">
							<h5>Uso CFDI <span v-if="editQuotation">*</span></h5>
							<p class="text-xs" v-if="!editQuotation"><b>{{findCfdi(currentQuotation.U_B1SYS_MainUsage).name}}</b></p>
							<div v-else>
								<multiselect 
									v-model="selectedCfdi"
									:options="cfdiOptions"
									label="name"
									track-by="code"
									class="mb-4"
									:disabled="!['federicoflores@canplast.com.mx',
															'bereniceterrazas@canplast.com.mx',
															'darinkahernandez@canplast.com.mx',
															'aideehernandez@canplast.com.mx',
															'dannasandoval@canplast.com.mx',
															'leslysifuentes@canplast.com.mx',
															'alfredoreyes@canplast.com.mx',
															'carlosjimenez@canplast.com.mx'].includes(user.email)">
								</multiselect>								
							</div>
						</div>
						<div class="col-12 col-lg-6">
							<h5>Comentarios</h5>
							<p class="text-xs" v-if="!editQuotation"><b>{{ currentQuotation.Comments }}</b></p>
							<base-input 
								inputClasses="input-group-alternative"
								placeholder="Comentarios" 
								v-model="currentQuotation.Comments" 
								v-else>
							</base-input>
						</div>	
						<div class="col-12 col-lg-6">
							<h5>Dirección</h5>
							<p class="text-xs"><b>{{ currentQuotation.Address.toString() }}</b></p>
						</div>				
						<div class="col-12 col-lg-6">
							<h5>Enviar a</h5>
							<p class="text-xs"><b>{{fullAddress(currentQuotation.AddressExtension)}}</b></p>
						</div>
				</div>
				<hr>
			</div>

			<div v-if="modal.quotation && currentQuotation && !loadingQuotation" class="mb-4">
				<h6 class="heading-small text-muted mb-4 modal-body">Artículos</h6>
				<div v-if="editQuotation" class="d-lg-flex pl-5 modal-body py-0">
					<div class="row flex-grow-1">
						<div class="col-12 col-lg-9">
							<multiselect 
								v-model="ProductSelectedEdit" 
								:options="articlesOptions"
								:loading="!articlesOptions.length > 0"
								placeholder="Buscar por código de producto"  
								:custom-label="x => {return `${x.ItemCode} (${x.ItemName})`}"
								track-by="ItemCode"
								class="mb-4">
							</multiselect>								
						</div>
						<div class="col-12 col-lg-3">
							<base-input 
								v-model="ProductSelectedQtyEdit"
								type="number"
								min="0"
								inputClasses="input-group-alternative"
								placeholder="Cantidad">
							</base-input>	
						</div>
					</div>
					<div class="ml-lg-4 text-right mb-4">
						<base-button @click="addArticle()" icon="fa fa-plus" :disabled="!ProductSelectedEdit">
							Agregar artículo
						</base-button>
					</div>
				</div>
				<div class="table-responsive">
					<base-table thead-classes="thead-light" :data="currentQuotation.DocumentLines">
						<template #columns>
							<th width="5%" class="pl-5"></th>
							<th width="20%">Artículo</th>
							<th width="40%">Descripción</th>
							<th width="10%" class="text-right">Precio Unitario</th>
							<th width="10%" class="text-right">Cantidad</th>
							<th width="10%" class="text-right pr-4">Subtotal</th>
						</template>
						<template #default="{ row }">
							<td width="5%" class="pl-5">
								<span v-if="row.LineStatus == 'bost_Open'" class="badge badge-success" title="Open">
									<i class="fas fa-lock-open"></i>
								</span>
								<span v-if="row.LineStatus == 'bost_Close'" class="badge badge-light" title="Close">
									<i class="fas fa-lock"></i>
								</span>
								<base-button @click="removeArticle(row.LineNum)" class="ml-4" type="danger" icon="fa fa-trash" size="sm"	v-if="row.LineStatus == 'bost_Open' && editQuotation">
								</base-button>
							</td>
							<td scope="row" width="20%">
								{{ row.ItemCode }}
								<p class="h5 text-primary m-0" v-if="row.U_SubCode">
									Sustituto: {{row.U_SubCode}}
								</p>
							</td>
							<td scope="row" width="40%">
								{{ row.ItemDescription }}
								<p class="h5 text-primary m-0" v-if="row.U_SubDescription">
									{{row.U_SubDescription}}
								</p>
							</td>
							<td scope="row" width="10%" class="text-right">
								<span v-if="!editQuotation">
									{{ new Intl.NumberFormat('mx-MX', { style: 'currency', currency: 'MXN' }).format(row.Price) }}
								</span>
								<base-input inputClasses="input-group-alternative" placeholder="Precio Unitario" v-model="row.Price"
									v-if="editQuotation" class="mb-0" type="number" min="0">
								</base-input>
							</td>
							<td scope="row" width="10%" class="text-right">
								<span v-if="!editQuotation">{{ row.Quantity }}</span>
								<base-input inputClasses="input-group-alternative" placeholder="Cantidad" v-model="row.Quantity"
									v-if="editQuotation" class="mb-0" type="number" min="0">
								</base-input>
							</td>
							<td scope="row"  width="10%" class="text-right  pr-4">
								<span>
									{{ new Intl.NumberFormat('mx-MX', { style: 'currency', currency: 'MXN' }).format(row.Quantity * row.Price) }}
								</span>
							</td>
						</template>
					</base-table>
				</div>
				<div v-if="!editQuotation" class="d-flex justify-content-end">
					<table class="text-right text-sm  mr-4">
						<tr>
							<th class="pr-4"><h5 class="my-1">Subtotal</h5></th>
							<td>
								{{ new Intl.NumberFormat('mx-MX', {style:'currency', currency: 'MXN'})
								.format(currentQuotation.DocTotalSys - currentQuotation.VatSumSys)}}
							</td>
						</tr>
						<tr>
							<th class="pr-4"><h5 class="my-1">IVA</h5></th>
							<td>
								{{ new Intl.NumberFormat('mx-MX', { style: 'currency', currency: 'MXN'})
								.format(currentQuotation.VatSumSys)}}
							</td>
						</tr>
						<tr>
							<th class="pr-4"><h5 class="my-1">Total</h5></th>
							<td>
								{{ new Intl.NumberFormat('mx-MX', { style: 'currency', currency: 'MXN'})
								.format(currentQuotation.DocTotalSys)}}
							</td>
						</tr>
					</table>
				</div>
			</div>
			<div :class="['d-flex  mb-4 modal-body py-0',
										editQuotation && savingQuotation ? 'justify-content-center' : 'justify-content-end']"  
									v-if="modal.quotation && currentQuotation && !loadingQuotation">
				<base-button 
					icon="fa fa-check" 
					@click="updateQuotation()" 
					v-if="editQuotation && !savingQuotation"
					:disabled="!selectedWhs ||
										!currentQuotation.DocCurrency ||
										!selectedSalesPerson ||
										!selectedCfdi ||
										currentQuotation.DocumentLines.length === 0">
					Guardar cambios
				</base-button>
				<base-loader v-if="editQuotation && savingQuotation" text="Guardando cambios"></base-loader>
			</div>
			<base-loader v-if="loadingQuotation" class="mt-n5 py-4"></base-loader>
		</b-modal>

		<!-- Modal Order Details -->
		<b-modal hide-footer v-model="modal.order" size="xl" bodyClass="p-0">
			<template #modal-header v-if="modal.order && currentOrder && !loadingOrder">
				<div class="d-lg-flex justify-content-between w-100">
					<div>
						<h3 class="text-uppercase">Pedido 
							<span class="badge badge-primary badge-pill text-blue text-sm font-weight" style="letter-spacing: .5px;">
								#{{ currentOrder.DocNum }}
							</span>
						</h3>
						<span class="text-sm text-muted">{{currentOrder.CardName}}</span>
					</div>
					<div class="d-flex align-items-center justify-content-between text-default">
						<table class="text-lg-right text-xs mr-3">
							<tr>
								<th class="pr-4"><b>Fecha de creación</b></th>
								<td>{{ currentOrder.DocDate }}</td>
							</tr>
							<tr>
								<th class="pr-4"><b>Fecha de vencimiento</b></th>
								<td>{{ currentOrder.DocDueDate }}</td>
							</tr>
						</table>
						<div>
							<base-button
							@click="downloadPdfFile('RDR20014', currentOrder, 'Pedido')"
							type="default" 
							icon="fa fa-file-pdf" 
							size="sm">
								Descargar
							</base-button>						
						</div>
					</div>
				</div>
			</template>
						
			<div v-if="modal.order && currentOrder && !loadingOrder" class="mt-n3 modal-body pb-0">
				<div class="row pl-4">
						<div class="col-6 col-lg-3">
							<h5>Almacén</h5>
							<p class="text-xs"><b>{{currentOrder.DocumentLines[0].WarehouseCode}}</b></p>
						</div>
						<div class="col-6 col-lg-3">
							<h5>Moneda</h5>
							<p class="text-xs"><b>{{ currentOrder.DocCurrency }}</b></p>
						</div>	
						<div class="col-6 col-lg-3">
							<h5>Vendedor</h5>
							<p class="text-xs"><b>{{ findSalesPerson(currentOrder.SalesPersonCode).SalesEmployeeName }}</b></p>
						</div>
						<div class="col-6 col-lg-3">
							<h5>Referencia</h5>
							<p class="text-xs"><b>{{ currentOrder.NumAtCard }}</b></p>
						</div>
						<div class="col-12 col-lg-6">
							<h5>Uso CFDI</h5>
							<p class="text-xs"><b>{{findCfdi(currentOrder.U_B1SYS_MainUsage).name}}</b></p>
						</div>
						<div class="col-12 col-lg-6">
							<h5>Comentarios</h5>
							<p class="text-xs"><b>{{ currentOrder.Comments }}</b></p>
						</div>	
						<div class="col-12 col-lg-6">
							<h5>Dirección</h5>
							<p class="text-xs"><b>{{ currentOrder.Address.toString() }}</b></p>
						</div>				
						<div class="col-12 col-lg-6">
							<h5>Enviar a</h5>
							<p class="text-xs"><b>{{fullAddress(currentOrder.AddressExtension)}}</b></p>
						</div>
					</div>
				<hr>
			</div>

			<div v-if="modal.order && currentOrder && !loadingOrder" class="mb-4">
				<h6 class="heading-small text-muted mb-4 modal-body">Artículos</h6>
				<div class="table-responsive">
					<base-table thead-classes="thead-light" :data="currentOrder.DocumentLines">
						<template #columns>
							<th width="20%" class="pl-5">Artículo</th>
							<th width="40%">Descripción</th>
							<th width="10%" class="text-right">Precio Unitario</th>
							<th width="10%" class="text-right">Cantidad</th>
							<th width="10%" class="text-right pr-4">Subtotal</th>
						</template>
						<template #default="{ row }">
							<td scope="row" width="20%" class="pl-5">
								{{ row.ItemCode }}
							</td>
							<td scope="row" width="40%">
								{{ row.ItemDescription }}
							</td>
							<td scope="row" width="10%" class="text-right">
								{{ new Intl.NumberFormat('mx-MX', { style: 'currency', currency: 'MXN' }).format(row.Price)}}
							</td>
							<td scope="row" width="10%" class="text-right">
								{{ row.Quantity }}
							</td>
							<td scope="row"  width="10%" class="text-right pr-4">
									{{ new Intl.NumberFormat('mx-MX', { style: 'currency', currency: 'MXN' })
									.format(row.Quantity * row.Price) }}
							</td>
						</template>
					</base-table>
				</div>
				<div class="d-flex justify-content-end mr-4">
					<table class="text-right text-sm">
						<tr>
							<th class="pr-4"><h5 class="my-1">Subtotal</h5></th>
							<td>
								{{ new Intl.NumberFormat('mx-MX', {style:'currency', currency: 'MXN'})
								.format(currentOrder.DocTotalSys - currentOrder.VatSumSys)}}
							</td>
						</tr>
						<tr>
							<th class="pr-4"><h5 class="my-1">IVA</h5></th>
							<td>
								{{ new Intl.NumberFormat('mx-MX', { style: 'currency', currency: 'MXN'})
								.format(currentOrder.VatSumSys)}}
							</td>
						</tr>
						<tr>
							<th class="pr-4"><h5 class="my-1">Total</h5></th>
							<td>
								{{ new Intl.NumberFormat('mx-MX', { style: 'currency', currency: 'MXN'})
								.format(currentOrder.DocTotalSys)}}
							</td>
						</tr>
					</table>
				</div>
			</div>
			<base-loader v-if="loadingOrder" class="mt-n5 py-4"></base-loader>
		</b-modal>
	</div>
</template>
<script>
import axios from 'axios';
import DTLoader from '@/components/DataTable/DTLoader.vue'
import DTButton from '@/components/DataTable/DTButton.vue';
import DTMoney from '@/components/DataTable/DTMoney.vue';
import Tab from '@/components/Tabs/Tab.vue';
import BaseLoader from '@/components/BaseLoader.vue';
import Multiselect from 'vue-multiselect'
import Event from "@/Event.js";
import { getAuth } from "firebase/auth";

export default {
	components: {
		Multiselect,
		BaseLoader,
		Tab
	},
	data() {
		return {
			user: null,
			customer: null,
			savingCustomer: false,
			savingQuotation: false,
			dtQuotations: {
				data: [],
				columns: [
					{
						title: "No. Cot.",
						key: "DocNum",
						type: "number"
					},
					{
						title: "Fecha",
						key: "DocDate",
					},
					{
						title: "Vencimiento",
						key: "DocDueDate"
					},
					{
						title: "SubTotal",
						key: "SubTotal",
						type: "number",
						component: DTMoney,
						extraData: {
							money: "SubTotal"
						}
					},
					{
						title: "Impuestos",
						key: "Taxes",
						type: "number",
						component: DTMoney,
						extraData: {
							money: "Taxes"
						}
					},
					{
						title: "Total",
						key: "DocTotalSys",
						type: "number",
						component: DTMoney,
						extraData: {
							money: "DocTotalSys"
						}
					},
					{
						title: "Vendedor",
						key: "SalesPerson",
					},
					{
						title: " ",
						key: "ItemCode",
						sortable: false,
						component: DTButton,
						extraData: {
							text: "Detalles",
							idClick: "openQuotation"
						}
					}
				],
				lang: "es",
				sortingMode: "single",
				showDownloadButton: false,
				loadingComponent: DTLoader,
				isLoading: true,
				defaultPerPage: 100,
				text: {
					previousButtonText: "❮",
					nextButtonText: "❯",
					searchText: "Buscar"
				},
			},
			dtOrders: {
				data: [],
				columns: [
					{
						title: "No. Pedido",
						key: "DocNum",
						type: "number"
					},
					{
						title: "Fecha",
						key: "DocDate",
					},
					{
						title: "Vencimiento",
						key: "DocDueDate",
					},
					{
						title: "Subtotal",
						key: "SubTotal",
						type: "number",
						component: DTMoney,
						extraData: {
							money: "SubTotal"
						}
					},
					{
						title: "Impuestos",
						key: "VatSumSys",
						type: "number",
						component: DTMoney,
						extraData: {
							money: "VatSumSys"
						}
					},
					{
						title: "Total",
						key: "DocTotalSys",
						type: "number",
						component: DTMoney,
						extraData: {
							money: "DocTotalSys"
						}
					},
					{
						title: "Vendedor",
						key: "SalesPerson",
					},
					{
						title: " ",
						sortable: false,
						component: DTButton,
						extraData: {
							text: "Detalles",
							idClick: "openOrder"
						}
					}
				],
				lang: "es",
				sortingMode: "single",
				showDownloadButton: false,
				loadingComponent: DTLoader,
				isLoading: true,
				defaultPerPage: 100,
				text: {
					previousButtonText: "❮",
					nextButtonText: "❯",
					searchText: "Buscar"
				},
			},
			dtInvoices: {
				data: [],
				columns: [
					{
						title: "Factura",
						key: "DocNum",
						type: "number"
					},
					{
						title: "Fecha",
						key: "DocDate",
					},
					{
						title: "PDF",
						sortable: false,
						component: DTButton,
						extraData: {
							idClick: "invoice_pdf",
							icon: "fa fa-file-pdf fa-lg",
							type: "danger",
							title: "Descargar Factura PDF"
						}
					},
					{
						title: "XML",
						sortable: false,
						component: DTButton,
						extraData: {
							idClick: "invoice_xml",
							icon: "fa fa-file-code fa-lg",
							type: "warning",
							title: "Descargar Factura XML"
						}
					}
				],
				lang: "es",
				sortingMode: "single",
				showDownloadButton: false,
				loadingComponent: DTLoader,
				isLoading: true,
				defaultPerPage: 100,
				text: {
					previousButtonText: "❮",
					nextButtonText: "❯",
					searchText: "Buscar"
				},
			},
			dtNotes: {
				data: [],
				columns: [
					{
						title: "No. Nota",
						key: "DocNum",
						type: "number"
					},
					{
						title: "Fecha",
						key: "DocDate",
					},
					{
						title: "PDF",
						sortable: false,
						component: DTButton,
						extraData: {
							idClick: "note_pdf",
							icon: "fa fa-file-pdf fa-lg",
							type: "danger",
							title: "Descargar Nota de Crédito PDF"
						}
					},
					{
						title: "XML",
						sortable: false,
						component: DTButton,
						extraData: {
							idClick: "note_xml",
							icon: "fa fa-file-code fa-lg",
							type: "warning",
							title: "Descargar Nota de Crédito XML"
						}
					}
				],
				lang: "es",
				sortingMode: "single",
				showDownloadButton: false,
				loadingComponent: DTLoader,
				isLoading: true,
				defaultPerPage: 100,
				text: {
					previousButtonText: "❮",
					nextButtonText: "❯",
					searchText: "Buscar"
				},
			},
			dtContacts: {
				data: [],
				columns: [
					{
						title: "Contacto",
						key: "Name"
					},
					{
						title: "Nombre",
						key: "PersonName",
					},
					{
						title: "Correo Electrónico",
						key: "E_Mail",
					},
					{
						title: "Teléfono",
						key: "Phone1",
					},
				],
				lang: "es",
				sortingMode: "single",
				showDownloadButton: false,
				loadingComponent: DTLoader,
				isLoading: true,
				defaultPerPage: 100,
				text: {
					previousButtonText: "❮",
					nextButtonText: "❯",
					searchText: "Buscar",

				},
			},
			taxData: {},
			salesPersonOptions: null,
			currentQuotation: [],
			loadingQuotation: false,
			currentOrder: [],
			loadingOrder: false,
			modal: {
				quotation: false,
				order: false
			},
			editQuotation: false,
			selectedWhs: null,
			ProductSelectedEdit: null,
      ProductSelectedQtyEdit:'',
			articlesOptions:[], 
			warehouseOptions:["CUU-02", "MEX-02", "GDL-02", "QRO-02", "MTY-02", "MID-02"],
			cfdiOptions:[
          {code: 'G01',  name: "G01 - Adquisición de mercancías"},
          {code: 'G02',  name: "G02 - Devoluciones, descuentos o bonificaciones"},
          {code: 'G03',  name: "G03 - Gastos en general"},
          {code: 'I01',  name: "I01 - Construcciones"},
          {code: 'I02',  name: "I02 - Mobilario y equipo de oficina por inversiones"},
          {code: 'I03',  name: "I03 - Equipo de transporte"},
          {code: 'I04',  name: "I04 - Equipo de cómputo y accesorios"},
          {code: 'I05',  name: "I05 - Dados, troqueles, moldes, matrices y herramental"},
          {code: 'I06',  name: "I06 - Comunicaciones telefónicas"},
          {code: 'I07',  name: "I07 - Comunicaciones satelitales"},
          {code: 'D01',  name: "D01 - Honorarios médicos, dentales y gastos hospitalarios"},
          {code: 'D02',  name: "D02 - Gastos médicos por incapacidad o discapacidad"},
          {code: 'D03',  name: "D03 - Gastos funerales"},
          {code: 'D04',  name: "D04 - Donativos"},
          {code: 'D05',  name: "D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)"},
          {code: 'D06',  name: "D06 - Aportaciones voluntarias al SAR"},
          {code: 'D07',  name: "D07 - Primas por seguros de gastos médicos"},
          {code: 'D08',  name: "D08 - Gastos de transportación escolar obligatoria"},
          {code: 'D09',  name: "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones"},
          {code: 'D10',  name: "D10 - Pagos por servicios educativos (colegiaturas)"},
          {code: 'P01',  name: "P01 - Por definir"},
        ],
			currencyOptions: ["MXP", "USD", "EUR"],
			stateOptions:[
        {code: 'AGS', name: "Aguascalientes"},
        {code: 'BC' , name: "Baja California"},
        {code: 'BCS', name: "Baja California Sur"},
        {code: 'CAM', name: "Campeche"},
        {code: 'CHI', name: "Chihuahua"},
        {code: 'CHS', name: "Chiapas"},
        {code: 'CMX', name: "Ciudad de México"},
        {code: 'COA', name: "Coahuila"},
        {code: 'COL', name: "Colima"},
        {code: 'DUR', name: "Durango"},
        {code: 'GTO', name: "Guanajuato"},
        {code: 'GRO', name: "Guerrero"},
        {code: 'HID', name: "Hidalgo"},
        {code: 'JAL', name: "Jalisco"},
        {code: 'MCH', name: "Michoacán"},
        {code: 'MEX', name: "Estado de México"},
        {code: 'MOR', name: "Morelos"},
        {code: 'NAY', name: "Nayarit"},
        {code: 'NL' , name: "Nuevo León"},
        {code: 'OAX', name: "Oaxaca"},
        {code: 'PUE', name: "Puebla"},
        {code: 'QR' , name: "Quintana Roo"},
        {code: 'QUE', name: "Querétaro"},
        {code: 'SIN', name: "Sinaloa"},
        {code: 'SLP', name: "San Luis Potosí"},
        {code: 'SON', name: "Sonora"},
        {code: 'TAB', name: "Tabasco"},
        {code: 'TAM', name: "Tamaulipas"},
        {code: 'TLA', name: "Tlaxcala"},
        {code: 'VER', name: "Veracruz"},
        {code: 'YUC', name: "Yucatán"},
        {code: 'ZAC', name: "Zacatecas"},
      ],
			selectedState: null,
			selectedCfdi: null,
			selectedSalesPerson: null,
			edit: false,
		}
	},
	created() {
		const auth = getAuth();
		this.user = auth.currentUser;
		this.getCustomer();

		axios.get(`/api/sales_persons`)
		.then((response) => {
			this.salesPersonOptions = response.data.value;
			this.getQuotations();
			this.getOrders();
			this.getInvoices();
			this.getNotes();			
		}).catch((error) => {
			console.error(error);
		});

		axios.get(`/api/items/list`)
		.then((response) => {
			this.articlesOptions = response.data;
		}).catch((error)=> {
			console.error(error);
		});	
	},
	methods: {
		load() {

		},	
		findSalesPerson(code){
			return this.salesPersonOptions.find(x => x.SalesEmployeeCode === code);
		},
		findCfdi(code){
			return this.cfdiOptions.find(x => x.code === code);
		},
		downloadPdfFile(docCode, obj, name){
			let json = {
				"DocCode": docCode,
				"Pairs": {
					"DocKey@": obj.DocEntry
				}
			};
			axios.post(`/api/pdf_file`,json)
			.then(response => {
				let link = document.createElement('a');
				link.download = `${name}_${obj.DocNum}.pdf`;
				link.href =  response.data.base64;
				link.click();
			})
			.catch(error => {
				console.error(error); 
			})
		},
		// Información General
		getCustomer(){
			axios.all([
          axios.get(`/api/business_partners?card_code=${this.$route.params.CardCode}`),
          axios.get(`/api/regimen_fiscal`),
      ])
      .then(axios.spread((...responses) => {
				this.customer = responses[0].data;
				this.dtContacts.isLoading = false;
				this.dtContacts.data = this.customer.ContactEmployees.map(x => { 
					return {
						Name : x.Name ? x.Name : "-",
						PersonName: `${x.FirstName ? x.FirstName : "-"} ${x.LastName ? x.LastName : "-" }`,
						E_Mail: x.E_Mail ? x.E_Mail : "-",
						Phone1: x.Phone1 ? x.Phone1 : "-" ,
				}});
				this.taxData = {
					cardName: responses[0].data.CardName,
					federalTaxID: responses[0].data.FederalTaxID,
					U_TS_RegFiscal: responses[1].data.find(x => x.Code === responses[0].data.U_TS_RegFiscal),
					zipCode: responses[0].data.BPAddresses[0].ZipCode,
					U_B1SYS_MainUsage: this.cfdiOptions.find(x => x.code === responses[0].data.U_B1SYS_MainUsage),
					U_FiscalCertificateLink: responses[0].data.U_FiscalCertificateLink
				}
				this.selectedState = this.stateOptions.find(x => x.code === this.customer.BPAddresses[0].State);
				this.edit = false;
      })).catch((error) =>{
				console.error(error);
			});
		},
		updateCustomer(){
			this.savingCustomer = true;
			var jsonUpdate = {
				"EmailAddress": this.customer.EmailAddress,
				"Phone1": this.customer.Phone1
			}
			axios.patch(`/api/business_partners?CardCode=${this.$route.params.CardCode}`, jsonUpdate)
			.then(() => {		
				this.$swal("","Información actualizada", "success");
				this.savingCustomer = false;
				this.edit = false;
      }).catch((error) => {
        this.$swal("Error", error, "error");
				this.savingCustomer = false;
      });
		},
		//Stats Cards
		positiveOpenOrdersBalance(value) {
			return Math.abs(value);
		},
		formatBalance(value) {
			let formatted = new Intl.NumberFormat('mx-MX', { style: 'currency', currency: 'MXN' }).format(value);
			return formatted;
		},
		// Cotizaciones
		getQuotations() {
			axios.get(`/api/quotes/by/card_code?card_code=${this.$route.params.CardCode}`)
        .then((result) => {
					this.dtQuotations.data = result.data.value.map((x) => {
						return {
							DocNum: x.DocNum,
							DocDate: x.DocDate,
							DocDueDate: x.DocDueDate,
							SubTotal: x.DocTotalSys - x.VatSumSys,
							Taxes: x.VatSumSys,
							DocTotalSys: x.DocTotalSys,
							SalesPerson: this.salesPersonOptions.find(y => y.SalesEmployeeCode === x.SalesPersonCode).SalesEmployeeName,
						}
					});
					this.dtQuotations.data = this.dtQuotations.data.sort(function (a, b) {
						return b.DocNum - a.DocNum
					});
        }).catch((error) => { 
					console.error(error); 
				}).finally(() => {
					this.dtQuotations.isLoading = false;					
				});
		},
		navNewQuotation() {
			this.$router.push({
				name: 'Nueva Cotización',
				params: { cardCode: this.$route.params.CardCode }
			});
		},
		getQuotation(docnum) {
			this.editQuotation = false;
			this.modal.quotation = true;
			this.loadingQuotation = true;
			axios.get(`/api/quotes/by/doc_num?doc_num=${docnum}`)
				.then((result) => {
					this.currentQuotation = result.data.value[0];
					this.selectedCfdi = this.cfdiOptions.find(x => x.code === this.currentQuotation.U_B1SYS_MainUsage);
					this.selectedSalesPerson = this.salesPersonOptions.find(x => x.SalesEmployeeCode === this.currentQuotation.SalesPersonCode);
					this.selectedWhs = this.currentQuotation.DocumentLines[0].WarehouseCode;
				}).catch((error) => { 
					console.error(error); 
				}).finally(() => {
					this.loadingQuotation = false;
				});
		},
		fullAddress(addressObj) {
			return [addressObj.ShipToStreet, 
							addressObj.ShipToStreetNo, 
              addressObj.ShipToBlock, 
              addressObj.ShipToZipCode, 
              addressObj.ZipCode, 
              addressObj.ShipToCity,
              addressObj.ShipToState,
              addressObj.ShipToCountry].filter(x => x).join(', '); 
		},
		addArticle(){
			axios.get(`/api/items/itemprice/${this.ProductSelectedEdit.ItemCode}`)
			.then((response) => {
				this.currentQuotation.DocumentLines.push({
            'ItemCode':this.ProductSelectedEdit.ItemCode,
            'ItemDescription':this.ProductSelectedEdit.ItemName,
            'Price': response.data.ItemPrices[0].Price,
            'Quantity':this.ProductSelectedQtyEdit,
            'LineTotal':'',
            'LineStatus':'bost_Open',
            'Nuevo': true,
            'showExistencias' : false,
            'LineNum': this.currentQuotation.DocumentLines.length
          })
          this.ProductSelectedEdit = null;
          this.ProductSelectedQtyEdit='';
					console.log("quo", this.currentQuotation)
			}).catch((error) => {
				console.error(error);
			});
    },
		removeArticle(LineNum){
			this.currentQuotation.DocumentLines.forEach((element, key) => {
				if(LineNum === element.LineNum){
					this.currentQuotation.DocumentLines.splice(key, 1)
				}
			});
		},
		updateQuotation(){
			this.savingQuotation = true;
			var documentLines = [];
      this.currentQuotation.DocumentLines.forEach((element, index) => {
        documentLines.push({
          "ItemCode":this.currentQuotation.DocumentLines[index].ItemCode,
          "Quantity":parseFloat(this.currentQuotation.DocumentLines[index].Quantity),
          "WarehouseCode":this.currentQuotation.DocumentLines[0].WarehouseCode,
          "UnitPrice":parseFloat(this.currentQuotation.DocumentLines[index].Price),
					"SalesPersonCode": this.selectedSalesPerson.SalesEmployeeCode,
          "FreeText":`Modificado por ${this.user.displayName} desde la Nueva Consola de Administración`,
        })
      });
      var jsonUpdate = {
				"U_Project" : this.currentQuotation.U_Project === null ? "N" : this.currentQuotation.U_Project,
        "DocCurrency":this.currentQuotation.DocCurrency,
        "SalesPersonCode":this.selectedSalesPerson.SalesEmployeeCode,
				"NumAtCard": this.currentQuotation.NumAtCard,
        "U_B1SYS_MainUsage":this.selectedCfdi.code,
				"Comments": this.currentQuotation.Comments,
        "DocumentLines": documentLines
      }
			axios.patch(`/api/quotes?DocEntry=${this.currentQuotation.DocEntry}`, jsonUpdate)
			.then(() => {
				this.modal.quotation = false;
				this.getQuotations();
				this.getQuotation(this.currentQuotation.DocNum);
				this.savingQuotation = false;
				this.$swal("", `Cotización #${this.currentQuotation.DocNum} actualizada`, "success");
      }).catch((error) => { 
					console.error(error); 
					this.savingQuotation = false;
			});
    },
		// Pedidos
		getOrders() {
			axios.get(`/api/orders/by/card_code?card_code=${this.$route.params.CardCode}`)
			.then((response) => {
				this.dtOrders.data = response.data.value.map((x) => {
					return {
						DocEntry: x.DocEntry,
						DocNum: x.DocNum,
						DocDate: x.DocDate,
						DocDueDate: x.DocDueDate,
						SubTotal:(x.DocTotalSys - x.VatSumSys),
						VatSumSys: x.VatSumSys,
						DocTotalSys: x.DocTotalSys,
						SalesPerson: this.salesPersonOptions.find(y => y.SalesEmployeeCode === x.SalesPersonCode).SalesEmployeeName,
					}
				});
				this.dtOrders.data = this.dtOrders.data.sort(function (a, b) {
					return b.DocNum - a.DocNum
				});
			}).catch((error) => {
				console.error(error);
			}).finally(() => {
				this.dtOrders.isLoading = false;
			}); 			
		},
		getOrder(docEntry){
			this.modal.order = true;
			this.loadingOrder = true;
			axios.get(`api/orders/${docEntry}`)
			.then(response => {
				this.currentOrder = response.data;
			}).catch(error => {
				console.error(error);
			}).finally(() => {
				this.loadingOrder = false;
			});
		},
		// Facturas
		getInvoices() {
			axios.get(`api/invoices/cardcode/${this.$route.params.CardCode}`)
			.then((response) =>{
						this.dtInvoices.data = response.data.value.map((x, index) => {
							return {
								index: index,
								CardCode: x.CardCode,
								CardName: x.CardName,
								DocEntry: x.DocEntry,
								DocNum: x.DocNum,
								DocDate: x.DocDate,
								U_WebXML: x.U_WebXML
							}
						});
						this.dtInvoices.data = this.dtInvoices.data.sort(function (a, b) {
							return b.DocEntry - a.DocEntry
						});
			}).catch((error => {
				console.error(error);
			})).finally(() => {
				this.dtInvoices.isLoading = false;	
			});
		},
		getInvoiceFile(row, type) {
			if(type === 'xml' && row.U_WebXML){
        let link_xml = document.createElement('a');
        link_xml.download = `Factura_${row.DocNum}.xml`;
        link_xml.href = row.U_WebXML;
        link_xml.target = '_blank';
        document.body.appendChild(link_xml);
        link_xml.click();
        document.body.removeChild(link_xml);
			} else {
			axios.post(`api/fiscal/electronic_docs`,{"document_type":"INV", "doc_entry":row.DocEntry})
			.then((response) =>{
				if(response.data.length> 0){
					if(response.data[0].U_TS_ReportID){
						window.open(`https://canplast.net:50000/api/v1/sap/${type}/${row.DocDate.substr(0, 4)}/${row.DocDate.substr(5, 2)}/${row.DocDate.substr(8, 2)}/${row.CardCode}/${row.CardName}/${response.data[0].U_TS_ReportID}?token=${localStorage.getItem('token-cpm')}`, '_blank');
					}
					else{
						fetch("https://canplast.net:50000/api/v1/sap/GET/Invoice/UUID/" + row.DocEntry, {
						method: 'GET',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'x-access-token': localStorage.getItem('token-cpm')
						}
					})
					.then((response) => response.json())
					.then((responseJson) => {
						if (responseJson) {
							window.open(`https://canplast.net:50000/api/v1/sap/${type}/${row.DocDate.substr(0, 4)}/${row.DocDate.substr(5, 2)}/${row.DocDate.substr(8, 2)}/${row.CardCode}/${row.CardName}/${responseJson.UUID}?token=${localStorage.getItem('token-cpm')}`, '_blank');
						}
					})
					.catch((error) => {
						console.error(error);
					});
					}
				}
				else{
					fetch("https://canplast.net:50000/api/v1/sap/GET/Invoice/UUID/" + row.DocEntry, {
						method: 'GET',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'x-access-token': localStorage.getItem('token-cpm')
						}
					})
					.then((response) => response.json())
					.then((responseJson) => {
						if (responseJson) {
							window.open(`https://canplast.net:50000/api/v1/sap/${type}/${row.DocDate.substr(0, 4)}/${row.DocDate.substr(5, 2)}/${row.DocDate.substr(8, 2)}/${row.CardCode}/${row.CardName}/${responseJson.UUID}?token=${localStorage.getItem('token-cpm')}`, '_blank');
						}
					})
					.catch((error) => {
						console.error(error);
					});
				}
			}).catch((error => {
				console.error(error);
			}))
			}
		},
		// Notas de Crédito
		getNotes(){
      this.notasList = null;
			axios.get(`/api/credit_notes/by/card_code?card_code=${this.$route.params.CardCode}`)
			.then((response) => {
				this.dtNotes.data = response.data.value.map((x, index) => {
					return {
						index: index,	
						DocEntry: x.DocEntry,
						CardCode: x.CardCode,
						CardName: x.CardName,
						DocNum: x.DocNum,	
						DocDate: x.DocDate,
						U_WebXML: x.U_WebXML
					}
				});
				this.dtNotes.data = this.dtNotes.data.sort(function (a, b) {
					return b.DocEntry - a.DocEntry
				});
			}).catch((error => {
				console.error(error);
			})).finally(() => {
				this.dtNotes.isLoading = false;
			});
    },
		getNoteFile(row, type){
			if(type === 'xml' && row.U_WebXML){
				let link_xml = document.createElement('a');
				link_xml.download = `Nota_Credito_${row.DocNum}.xml`;
				link_xml.href = row.U_WebXML;
				link_xml.target = '_blank';
				document.body.appendChild(link_xml);
				link_xml.click();
				document.body.removeChild(link_xml);

			} else {

			axios.post(`api/fiscal/electronic_docs`,{"document_type":"CN", "doc_entry":row.DocEntry})
			.then((response) =>{
				console.log("🚀 ~ file: Customer.vue:1375 ~ .then ~ response:", response)
				if(response.data.length> 0){
					if(response.data[0].U_TS_ReportID){
						window.open(`https://canplast.net:50000/api/v1/sap/${type}/${row.DocDate.substr(0, 4)}/${row.DocDate.substr(5, 2)}/${row.DocDate.substr(8, 2)}/${row.CardCode}/${row.CardName}/${response.data[0].U_TS_ReportID}?token=${localStorage.getItem('token-cpm')}`, '_blank');
					}
					else{
						fetch("https://canplast.net:50000/api/v1/sap/GET/CreditNotes/withUUID/"+row.DocNum,{
						method: 'GET',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'x-access-token':localStorage.getItem('token-cpm')
						}
						})
						.then((response) => response.json())
						.then((responseJson) => {
						if(responseJson){
							window.open(`https://canplast.net:50000/api/v1/sap/${type}/${row.DocDate.substr(0, 4)}/${row.DocDate.substr(5, 2)}/${row.DocDate.substr(8, 2)}/${row.CardCode}/${row.CardName}/${responseJson.UUID}?token=${localStorage.getItem('token-cpm')}`, '_blank');
						}
						})
						.catch((error) => {
							console.error(error);
						});	
					}
				}
				else{
					fetch("https://canplast.net:50000/api/v1/sap/GET/CreditNotes/withUUID/"+row.DocNum,{
					method: 'GET',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'x-access-token':localStorage.getItem('token-cpm')
					}
					})
					.then((response) => response.json())
					.then((responseJson) => {
					if(responseJson){
						window.open(`https://canplast.net:50000/api/v1/sap/${type}/${row.DocDate.substr(0, 4)}/${row.DocDate.substr(5, 2)}/${row.DocDate.substr(8, 2)}/${row.CardCode}/${row.CardName}/${responseJson.UUID}?token=${localStorage.getItem('token-cpm')}`, '_blank');
					}
					})
					.catch((error) => {
						console.error(error);
					});	
				}
			}).catch((error => {
				console.error(error);
			}))
			}
		}
	},
	mounted() {
		this.load();
		Event.listen("Click", (row, id) => {
			if (id === 'invoice_pdf') {
				let docCode = 'INV20024';
				if(row.CardCode === 'C04562'){
					docCode = 'INV20025';
				}
				this.downloadPdfFile(docCode, row, 'Factura');
			}
			else if (id === 'invoice_xml'){
				this.getInvoiceFile(row, "xml");
			}
			else if (id === 'note_pdf') {
				this.downloadPdfFile('RIN20015', row, 'Nota_Credito');
			}
			else if (id === 'note_xml'){
				this.getNoteFile(row, "xml");
			}
			else if (id === 'openQuotation') {
				this.getQuotation(row.DocNum);
			}
			else if (id === 'openOrder') {
				this.getOrder(row.DocEntry);
			}
		});
	}
}
</script>
<style>
.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
	background: linear-gradient(87deg, #f5365cd7 0, #f55f36d3 200%) !important;
}
.nav-pills .nav-link {
	font-weight: 600 !important;
}
#dt_quotations>.data-table-pagination,
#dt_orders>.data-table-pagination,
#dt_invoices>.data-table-pagination,
#dt_notes>.data-table-pagination,
#dt_contacts>.data-table-pagination {
	grid-area: pagination / pagination / pagination / download;
}
</style>